import { render } from "./Firewall.vue?vue&type=template&id=c5612334"
import script from "./Firewall.vue?vue&type=script&lang=js"
export * from "./Firewall.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__